export const messages = {
    services: {
        bullet: "●",
        pretitle: "Comenzá ahora",
        title: "El camino inicia",
        title2: "con una idea",
        subtitle: "Las ideas seleccionadas participarán de un programa que incluye:",
    }
}